import { PublicAssetSources } from './types';

const ImageProviderInfo: Record<PublicAssetSources, { displayName: string; translationKey?: string }> = {
  [PublicAssetSources.Bridgeman]: {
    displayName: 'Bridgeman Images',
    translationKey: 'txt_bridgeman_images',
  },
  [PublicAssetSources.ManualUpload]: {
    displayName: 'Manual Upload',
  },
  [PublicAssetSources.Shutterstock]: {
    displayName: 'Shutterstock',
  },
};

export default ImageProviderInfo;
